import { Grid, LinearProgress, makeStyles } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import PaginationComponent from '../../components/PaginationComponent'
import {
  getPartnersClippingListByPartner as getData,
  searchClipping
} from '../../services/ClippingApi'
import { getSearch } from '../../services/ClubeApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import ToastMessages from '../../components/ToastMessages'
import TopSearch from '../../components/TopSearch'

import Context from '../../context'
import history from '../../services/history'

function ClippingPage() {
  const [searchData, setSearchData] = useState({ str: '', startSearch: false })
  const [page, setPage] = useState(0)
  const [totalPages, setTotalPages] = useState(5)
  const { setUser, setAboutCurrentPage, user } = useContext(Context)
  const [data, setData] = useState(null)
  const [fullData, setFullData] = useState(null)
  const [loading, setLoading] = useState(false)
  const classes = useStyles()

  const listUpdate = async () => {
    setLoading(true)
    const actualPage = page || 1
    return getData(actualPage, 25, user?.userGroup)
  }

  useEffect(() => {
    if (!isAuthenticated) return history.replace('/')
    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: 'Clipping de Parceiros',
      buttons: [{ pathname: '/clippingform', title: 'Adicionar' }]
    })

    listUpdate()
      .then(r => {
        const { pagination } = r
        setFullData(r.data || [])
        setPage(pagination.page || 1)
        setTotalPages(pagination.totalPages || 1)
        setLoading(false)
      })
      .catch(error => {
        console.log('error', error)
      })
  }, [])

  useEffect(() => {
    if (searchData.startSearch && user) {
      setLoading(true)
      searchClipping('clipping', searchData.str, user?.userGroup).then(r => {
        console.log(r)
        setData(r)
        setSearchData({ ...searchData, startSearch: false })
        setLoading(false)
      })
    }

    if (!searchData.startSearch && searchData.str === '') {
      setData(fullData)
    }
  }, [searchData])

  useEffect(() => {
    if (user) {
      listUpdate().then(r => {
        const { data } = r

        setFullData(data)
        setLoading(false)
      })
    }
  }, [page, user])

  useEffect(() => {
    if (fullData && fullData.length > 0) {
      setData(fullData)
    }
  }, [fullData])

  return (
    <div className={classes.outerContainer}>
      <div className={classes.content}>
        {user?.partnerId ? null : (
          <Grid item xs={12}>
            <ToastMessages />
            <Context.Provider value={{ searchData, setSearchData }}>
              <TopSearch />
            </Context.Provider>
          </Grid>
        )}
        {loading ? <LinearProgress style={{ marginTop: 30 }} /> : null}
        <table className={classes.table}>
          <colgroup>
            <col />
            <col className={classes.fitContent} />
          </colgroup>
          <thead>
            <tr>
              <td>Parceiro</td>
              <td>Itens</td>
            </tr>
          </thead>
          <tbody>
            {!data
              ? null
              : data.map(item => (
                  <tr key={item.partner.id}>
                    <td className={classes.partnerContainer}>
                      <div>{item.partner.fantasyName}</div>
                      <div>
                        <Link
                          to={{
                            pathname: '/clippingpartner',
                            state: { clippingPartnerDetails: item }
                          }}
                        >
                          Ver detalhes
                        </Link>
                      </div>
                    </td>
                    <td>
                      {item.clippings.length === 1 ? 'Um item' : `${item.clippings.length} itens`}
                    </td>
                  </tr>
                ))}
          </tbody>
        </table>
        {user?.partnerId ? null : (
          <Grid item xs={12}>
            <Context.Provider value={{ page, setPage, totalPages }}>
              <PaginationComponent />
            </Context.Provider>
          </Grid>
        )}
      </div>
    </div>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '40px 45px'
  },
  table: {
    marginTop: '20px',
    whiteSpace: 'nowrap',
    border: '2px solid #30287b',
    '& td': {
      border: '2px solid #30287b'
    },
    '& thead': {
      background: '#30287b'
    },
    '& thead td': {
      fontSize: '12px',
      padding: '17px 25px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '13px',
      textTransform: 'uppercase'
    },
    '& tbody td': {
      fontSize: '14px',
      padding: '17px 25px',
      color: '#30287b'
    }
  },
  fitContent: {
    width: 'fit-content'
  },
  partnerContainer: {
    '& div:first-child': {
      marginBottom: '17px',
      fontWeight: '700'
    },
    '& div:last-child': {
      fontSize: '12px',
      '& a': {
        cursor: 'pointer',
        color: '#30287b'
      }
    }
  }
})

export default ClippingPage
